// extracted by mini-css-extract-plugin
export default {"link":"NavArrow_link__uWhyK","arrowBack":"NavArrow_arrowBack__auaJi","arrowForward":"NavArrow_arrowForward__CTvJ6"};